// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__ACpWN","productName":"Table_productName__26Gyt"};